import React from "react";
import { Stack, Button, TextField, Typography } from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";

const SUBROLES = [
  { id: "hs_counselor", label: "High School Counselor" },
  { id: "college_admin", label: "College Administrator" },
  { id: "financial_advisor", label: "Financial Advisor" },
  { id: "iec", label: "Independent Education Counselor (IEC)" },
  { id: "cbo", label: "Community-Based Organization (CBO)" },
  { id: "other_describe", label: "Other (Describe)" },
];

export default function OtherRoleChooser({
  value,
  onChange,
  description,
  onChangeDescription,
}) {
  const handlePick = (id) => {
    onChange(id);
  };

  return (
    <div className="mt-4 border-t border-slate-200 pt-4 rounded-b-xl bg-white px-5 py-4">
      <Stack direction="row" flexWrap="wrap" gap={1.5} className="mb-4">
        {SUBROLES.map((item) => {
          const selected = value === item.id;
          return (
            <Button
              key={item.id}
              variant="outlined"
              color={selected ? "primary" : "inherit"}
              onClick={() => handlePick(item.id)}
              className={`rounded-lg normal-case ${selected ? "shadow-none outline-sky-600 bg-primary-50" : ""}`}
              sx={{
                borderRadius: 999,
                px: 2.2,
                py: 1,
                borderColor: selected ? "primary.main" : "#E2E8F0",
              }}
            >
              {item.label}
              {selected && <CheckIcon className="ml-2" fontSize="small" />}
            </Button>
          );
        })}
      </Stack>

      {value === "other_describe" && (
        <div className="mt-2">
          <Typography variant="subtitle2" className="text-slate-500 mb-1">
            Describe
          </Typography>
          <TextField
            fullWidth
            placeholder="write here"
            value={description}
            onChange={(item) => onChangeDescription(item.target.value)}
            InputProps={{
              className: "rounded-xl",
            }}
          />
        </div>
      )}
    </div>
  );
}
